var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{staticClass:"item",on:{"click":_vm.exec}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"size":"lg"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }